import axios from 'axios';
import React from 'react';
import configuration from '../../configuration';
import ClinicDepartmentsListItem from './ClinicDepartmentsListItem';

const ClinicDepartmentsList = ({ departments }) => {
  const [departmentData, setDepartmentData] = React.useState({});
  React.useState(() => {
    departments.forEach(department => {
      axios.get(configuration.backendAddress + '/open/getDepartments?id=' + department.id)
        .then(result => {
          setDepartmentData(old => ({ ...old, [department.id]: { ...result.data[0], ...department } }));
        })
        .catch(err => console.log(err));
    });
  }, [departments]);

  const compare = (a, b) => {
    if (departmentData[a].rating_count < departmentData[b].rating_count) {
      return 1;
    }
    if (departmentData[a].rating_count > departmentData[b].rating_count) {
      return -1;
    }
    return 0;
  };

  const departmentList = Object.keys(departmentData);
  const surgerySubjects = departmentList.filter(d => departmentData[d].subject_areas?.filter(s => s.toLowerCase().includes('chirurgie')).length > 0).sort(compare);
  const internSubjects = departmentList.filter(d => departmentData[d].subject_areas?.filter(s => s.toLowerCase().includes('innere')).length > 0).sort(compare);
  const otherSubjects = departmentList.filter(d => departmentData[d].subject_areas?.filter(s => !s.toLowerCase().includes('chirurgie') && !s.toLowerCase().includes('innere') && !s.toLowerCase().includes('geriatrie')).length > 0).sort(compare);

  // console.log(Object.keys(departmentData).sort(compare));

  return (
    <div>
      {
        internSubjects.length > 0 && (
          <>
            <h5>Internistische Fächer</h5>
            {
              internSubjects.map((departmentId, i) => {
                const departmentProps = departmentData[departmentId];
                if (departmentProps.parent_id) return null;
                return (
                  <ClinicDepartmentsListItem
                    key={i}
                    {...departmentProps}
                  />
                );
              })
            }
          </>
        )
      }
      {
        surgerySubjects.length > 0 && (
          <>
            <h5>Chirurgische Fächer</h5>
            {
              surgerySubjects.map((departmentId, i) => {
                const departmentProps = departmentData[departmentId];
                if (departmentProps.parent_id) return null;
                return (
                  <ClinicDepartmentsListItem
                    key={i}
                    {...departmentProps}
                  />
                );
              })
            }
          </>
        )
      }
      {
        otherSubjects.length > 0 && (
          <>
            <h5>Weitere Fächer</h5>
            {
              otherSubjects.map((departmentId, i) => {
                const departmentProps = departmentData[departmentId];
                if (departmentProps.parent_id) return null;
                return (
                  <ClinicDepartmentsListItem
                    key={i}
                    {...departmentProps}
                  />
                );
              })
            }
          </>
        )
      }
    </div>
  );
};

export default ClinicDepartmentsList;
